import { RootState } from '@reducers';

export const selectFeatureBenefitTemplate = (state: RootState) => state.featureReducer.benefitTemplateReducer;
